import { render, staticRenderFns } from "./TableScorePercent.vue?vue&type=template&id=f6f251da&scoped=true"
import script from "./TableScorePercent.vue?vue&type=script&lang=js"
export * from "./TableScorePercent.vue?vue&type=script&lang=js"
import style0 from "./TableScorePercent.vue?vue&type=style&index=0&id=f6f251da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6f251da",
  null
  
)

export default component.exports